import { activityMandatoryFieldsDefaultValue } from '~/toggles/default-values/organizer/activity/by-type-mandatory-fields';

export enum ParamethorNameEnum {
  ActivityCreationBirthdayType = 'ACTIVITY_CREATION_BIRTHDAY_TYPE',
  ActivityCreationGroupLessonType = 'ACTIVITY_CREATION_GROUP_LESSON_TYPE',
  ActivityCreationLiveType = 'ACTIVITY_CREATION_LIVE_TYPE',
  ActivityCreationMultiDayCourseType = 'ACTIVITY_CREATION_MULTI_DAY_COURSE_TYPE',
  ActivityCreationEvent = 'ACTIVITY_CREATION_EVENT_TYPE',
  ActivityCreationPlaygroundRentType = 'ACTIVITY_CREATION_PLAYGROUND_RENT_TYPE',
  ActivityCreationProductTest = 'ACTIVITY_CREATION_TEST_TYPE',
  ActivityCreationWorkshopType = 'ACTIVITY_CREATION_WORKSHOP_TYPE',
  ActivityLoyaltyPoints = 'ACTIVITY_LOYALTY_POINTS',
  AttendeeResultsActivitiesTab = 'ATTENDEE_RESULTS_ACTIVITIES_TAB',
  AttendeeResultsExternalActivitiesTab = 'ATTENDEE_RESULTS_EXTERNAL_ACTIVITIES_TAB',
  AttendeeResultsLiveActivitiesTab = 'ATTENDEE_RESULTS_LIVE_ACTIVITIES_TAB',
  AllowExternalPayment = 'ALLOW_EXTERNAL_PAYMENT',
  OnlinePaymentOutageBanner = 'ONLINE_PAYMENT_OUTAGE_BANNER',
  AutocompleteAllowedTypes = 'AUTOCOMPLETE_ALLOWED_TYPES',
  BookingLimit = 'BOOKING_LIMIT',
  CountriesAddressRegionField = 'COUNTRIES_ADDRESS_REGION_FIELD',
  Currency = 'CURRENCY',
  DecatClubUrl = 'DECAT_CLUB_URL',
  DefaultPaidOfferName = 'DEFAULT_PAID_OFFER_NAME',
  Onepay = 'ONEPAY',
  ExcludedSports = 'EXCLUDED_SPORTS',
  ExcludedSportsGroups = 'EXCLUDED_SPORTS_GROUPS',
  LegalTermsUsageParticipantUrl = 'LEGAL_TERMS_USAGE_PARTICIPANT_URL',
  LegalTermsSalesUrl = 'LEGAL_TERMS_SALES_URL',
  MajorityAge = 'MAJORITY_AGE',
  OrganizerInvoicesLink = 'ORGANIZER_INVOICES_LINK',
  OrganizerSharedGuardActivityByTypeMandatoryFields = 'SHARED_ORGANIZER_GUARD_ACTIVITY_BY_TYPE_MANDATORY_FIELDS',
  OnePartnerDashboardUrl = 'ONE_PARTNER_DASHBOARD_URL',
  LoginBeforeExternalBooking = 'LOGIN_BEFORE_EXTERNAL_BOOKING',
  SkipOfferNameSlugify = 'SKIP_OFFER_NAME_SLUGIFY',
  TimezoneSelection = 'TIMEZONE_SELECTION',
  PromoCode = 'PROMO_CODE',
  ValidatorPhoneNumber = 'VALIDATOR_PHONE_NUMBER',
  ValidatorPostalCode = 'VALIDATOR_POSTAL_CODE',
}

// Default values to be used when Paramethor is unreachable, most suited with FRA environment
export const paramethorFallbackValues: { [key in ParamethorNameEnum]: string } =
  {
    [ParamethorNameEnum.ActivityCreationBirthdayType]: 'false',
    [ParamethorNameEnum.ActivityCreationEvent]: 'true',
    [ParamethorNameEnum.ActivityCreationGroupLessonType]: 'true',
    [ParamethorNameEnum.ActivityCreationLiveType]: 'true',
    [ParamethorNameEnum.ActivityCreationMultiDayCourseType]: 'true',
    [ParamethorNameEnum.ActivityCreationPlaygroundRentType]: 'true',
    [ParamethorNameEnum.ActivityCreationProductTest]: 'false',
    [ParamethorNameEnum.ActivityCreationWorkshopType]: 'true',
    [ParamethorNameEnum.ActivityLoyaltyPoints]: 'true',
    [ParamethorNameEnum.AllowExternalPayment]: 'false',
    [ParamethorNameEnum.AttendeeResultsActivitiesTab]: 'true',
    [ParamethorNameEnum.AttendeeResultsExternalActivitiesTab]: 'false',
    [ParamethorNameEnum.AttendeeResultsLiveActivitiesTab]: 'true',
    [ParamethorNameEnum.OnlinePaymentOutageBanner]: 'false',
    [ParamethorNameEnum.AutocompleteAllowedTypes]: 'locality,neighborhood',
    [ParamethorNameEnum.BookingLimit]: '{ "adults": 100, "childrens": 100 }',
    [ParamethorNameEnum.CountriesAddressRegionField]: 'false',
    [ParamethorNameEnum.Currency]: 'EUR',
    [ParamethorNameEnum.DecatClubUrl]: 'https://decatclub.decathlon.fr/',
    [ParamethorNameEnum.DefaultPaidOfferName]: 'paid',
    [ParamethorNameEnum.ExcludedSports]:
      '10,11,31,34,35,36,37,208,209,210,211,212,213,214,268,270,271,272,274,275,276,310,311,313,314,315,316,317,319,355,356,357,358,359,360,361,423,524,544,545,548,561,581,606,618,632,637,652,655,659',
    [ParamethorNameEnum.ExcludedSportsGroups]:
      '262,273,274,276,278,280,281,282,283,284,285,277,270,275,242,279,267,287,266,264,263,256,255,254,253,252,251,250,249,248,247,246,245,243,241,240,239,238,237,236,235,234,232,231,230,229,228,227,226,225,224,223,222,221,220,219,218,217,216,215,214,213,212,211,210,209,208,207,206,205,204,203,202,200,199,198,197,196,194,193,192,191,190,188,187,186,185,184,183,182,181,180,179,178,177,176,175,174,173,172,171,170,169,168,167,166,165,164,163,162,161,160,159,158,157,156,155,154,153,152,151,150,149,148,147,146,145,144,143,142,141,140,139,138,137,136,135,134,133,132,131,130,129,128,127,126,125,124,123,122,121,120,119,118,117,116,115,114,113,112,111,110,109,108,107,106,105,104,103,102,101,100,99,98,97,96,95,94,93,92,91,90,89,88,87,86,85,84,83,82,81,80,79,78,77,76,75,73,72,71,70,69,68,67,66,65,63,62,61,60,59,58,56,55,54,53,52,51,50,49,48,47,46,45,44,43,42,41,40,39,38,37,36,35,34,32,31,30,29,28,24,22,19,4,2,265,259,3,15,18,997,996,998,995,269,268,1001,272,271,999,286,288,260',
    [ParamethorNameEnum.LegalTermsSalesUrl]:
      '/pages/conditions-generales-vente',
    [ParamethorNameEnum.LegalTermsUsageParticipantUrl]:
      'https://activites.decathlon.fr/pages/conditions-generales-utilisation',
    [ParamethorNameEnum.OnePartnerDashboardUrl]: 'https://partner.decathlon.com/dashboard/',
    [ParamethorNameEnum.LoginBeforeExternalBooking]: 'false',
    [ParamethorNameEnum.MajorityAge]: '18',
    [ParamethorNameEnum.Onepay]: 'true',
    [ParamethorNameEnum.OrganizerInvoicesLink]: 'true',
    [ParamethorNameEnum.OrganizerSharedGuardActivityByTypeMandatoryFields]:
      JSON.stringify(activityMandatoryFieldsDefaultValue),
    [ParamethorNameEnum.PromoCode]: 'true',
    [ParamethorNameEnum.SkipOfferNameSlugify]: 'false',
    [ParamethorNameEnum.TimezoneSelection]: 'true',
    [ParamethorNameEnum.ValidatorPhoneNumber]: String.raw`^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$`,
    [ParamethorNameEnum.ValidatorPostalCode]: null,
  };
